import { IConfig } from '@cian/config/shared';
import {
  IMappers,
  ISuggestRosreestrDataRequest,
} from '../../../repositories/countryside-rosreestr/v1/suggest-rosreestr-data';
import { IRosreestrDataResponseFail, IRosreestrDataResponseSuccess } from './types';
import { mapParameters } from './utils/mapParameters';

export const getMappers = (
  parameters: ISuggestRosreestrDataRequest,
  config: IConfig,
): IMappers<IRosreestrDataResponseSuccess, IRosreestrDataResponseFail> => ({
  200: ({ address, cardView, errors, autofields }) => ({
    success: true,
    payload: {
      address,
      cardView,
      autofields,
      meta: mapParameters(parameters, errors, config),
    },
  }),
  400: () => ({ success: false }),
});
